import { render, staticRenderFns } from "./marcaravistamento.vue?vue&type=template&id=72b1f273"
import script from "./marcaravistamento.vue?vue&type=script&lang=js"
export * from "./marcaravistamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports